module.exports = __webpack_public_path__ + "img/lp-globe.5412fa5e.svg";